import React from "react";
import { toTitleCase } from "../../../../Utils/stringUtls";
import ReviewAttribute from "../../../../Components/SharedComponent/ReviewAttribute/ReviewAttribute";
import EmptyState from "../../../../Components/SharedComponent/EmptyState/EmptyState";
import { formatReviewDate } from "../reviewSummaryUtils";

const I2CStakeholderSignOffOverview = ({ data }) => {
  const getStakeholderSignoffs = () => {
    if (Array.isArray(data)) return data;

    if (typeof data === "string" && data.trim()) {
      try {
        const parsedData = JSON.parse(data);
        return Array.isArray(parsedData) ? parsedData : [];
      } catch (error) {
        console.warn("Invalid stakeholder signoff data", error);
        return [];
      }
    }

    return [];
  };

  const formatSignoffDate = (signoffDate, signoffAt) => {
    // First priority: use signoff_date if available
    if (signoffDate) {
      return formatReviewDate(signoffDate);
    }

    // Second priority: use signoff_at if available
    if (signoffAt) {
      return formatReviewDate(signoffAt);
    }

    // Fallback: show "-"
    return "-";
  };

  const stakeholderSignoffs = getStakeholderSignoffs();

  if (stakeholderSignoffs.length === 0) {
    return (
      <EmptyState
        title="No Stakeholder Sign-offs Available"
      />
    );
  }

  return (
    <div className="forms-instance" style={{ color: "#111" }}>
      {stakeholderSignoffs.map((stakeholder, index) => (
        <div
          key={`${stakeholder.type}-${stakeholder.user_id}-${index}`}
          i2c-grid="grid"
          className="review-summary-gap"
          style={{
            marginBottom: index < stakeholderSignoffs.length - 1 ? "2rem" : "0",
          }}
        >
          <div i2c-grid="12@md" className="review-summary-sub-heading">
            <div className="fw-700 font-bold">
              {stakeholder.type
                ? toTitleCase(stakeholder.type.replace(/_/g, " "))
                : "-"}
            </div>
          </div>
          <div i2c-grid="9@md">
            <div i2c-grid="grid grid" className="review-summary-gap">
              <div i2c-grid="6@md">
                <ReviewAttribute label="Name" value={stakeholder.user_name} />
              </div>
              <div i2c-grid="6@md">
                <ReviewAttribute
                  label="Title"
                  value={stakeholder.job_title}
                />
              </div>
              <div i2c-grid="6@md">
                <ReviewAttribute label="Email" value={stakeholder.user_email} />
              </div>
              <div i2c-grid="6@md">
                <ReviewAttribute
                  label="Status"
                  value={
                    stakeholder.status ? toTitleCase(stakeholder.status) : "-"
                  }
                />
              </div>
              <div i2c-grid="6@md">
                <ReviewAttribute
                  label="Signoff Date"
                  value={formatSignoffDate(stakeholder.signoff_date, stakeholder.signoff_at)}
                />
              </div>
              <div i2c-grid="6@md">
                <ReviewAttribute
                  label="Comments"
                  value={stakeholder.comments}
                />
              </div>
            </div>
          </div>
          <div i2c-grid="3@md">
            {true && (
              <div>
                <div className="overview-help-text">Signature</div>
                {stakeholder.signature ? (
                  <img
                    src={stakeholder.signature}
                    alt="Signature"
                    className="signature-image"
                  />
                ) : (
                  <div className="overview-val-text">-</div>
                )}
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default I2CStakeholderSignOffOverview;
